/**
 * FilesPage Component
 *
 * Main page for browsing and downloading railML files
 * Features:
 * - File list table
 * - File metadata display
 * - Download functionality
 */

import { useTranslation } from 'react-i18next';
import { Heading, Text } from '@bn-apps/design-system-ui-react';
import { Container, PageHeader } from '@bn-apps/dim-ui-react';
import { useRailMLFiles } from '@hooks/useSparql';
import FileList from '@components/files/FileList';
import styles from './FilesPage.module.scss';
import appStyles from '@/App.module.scss';

function FilesPage(): JSX.Element {
  const { t } = useTranslation();

  // Load all files
  const {
    data: files,
    loading: loadingFiles,
    error: errorFiles,
    refetch,
  } = useRailMLFiles();

  return (
    <Container className={appStyles.pageContent}>
      <div className="bn-mbe-1000">
        <PageHeader title={t('files.title')} lead={t('files.description')} />
      </div>

      <main>
        <FileList
          files={files}
          loading={loadingFiles}
          error={errorFiles}
          onRefresh={refetch}
        />

        <div className={styles['splitting-section']}>
          <div>
            <Heading level={2} fontSize="xl" className="bn-mbe-400">
              {t('files.splitting.header')}
            </Heading>
            <Text fontSize="md">
              {t('files.splitting.description')}
            </Text>
          </div>
          <div>
            <img src="/svg/kvgb_ink.svg" alt="" className={styles['splitting-image']} />
          </div>
        </div>
      </main>
    </Container>
  );
}

export default FilesPage;
